/*
  Три вкладки карточки счёта с внесением руками (20.10.2026): «Начисления», «Оплаты»,
  «Проживающие». Вынесено из `pages/AccountPage.jsx`: страница стояла у предела размера
  (250 строк норма), а вкладки отличаются только содержимым.

  Содержимое невыбранной вкладки не рисуется (`TabPanel`): иначе таблицы грузились бы при
  открытии карточки, а не по требованию. Видят вкладки все, кто видит реестр; кнопки
  внесения и правки - только те, у кого право собирать документы (`canEdit`).
*/

import { TabPanel } from '../Tabs.jsx'
import ChargesTab from './ChargesTab.jsx'
import PaymentsTab from './PaymentsTab.jsx'
import ResidentsTab from './ResidentsTab.jsx'

export const ENTRY_TABS = [
  { key: 'charges', title: 'Начисления' },
  { key: 'payments', title: 'Оплаты' },
  { key: 'residents', title: 'Проживающие' },
]

export default function AccountEntryTabs({ accountId, active, canEdit, onDone }) {
  return (
    <>
      <TabPanel tabKey="charges" active={active}>
        <ChargesTab accountId={accountId} canEdit={canEdit} onDone={onDone} />
      </TabPanel>
      <TabPanel tabKey="payments" active={active}>
        <PaymentsTab accountId={accountId} canEdit={canEdit} onDone={onDone} />
      </TabPanel>
      <TabPanel tabKey="residents" active={active}>
        <ResidentsTab accountId={accountId} canEdit={canEdit} onDone={onDone} />
      </TabPanel>
    </>
  )
}
